import { render } from "./Gatekeeper.vue?vue&type=template&id=97bc2aee&scoped=true"
import script from "./Gatekeeper.vue?vue&type=script&lang=js"
export * from "./Gatekeeper.vue?vue&type=script&lang=js"

import "./Gatekeeper.vue?vue&type=style&index=0&id=97bc2aee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97bc2aee"]])

export default __exports__